import { useContext, useCallback, useMemo } from 'react';
import { Icons, ListItemProps } from '@silverfort/sf-components';
import IncidentExclusionContext from '../incidentExclusionContext';
import { Exclusion } from '../../../api/types/Exclusions';

const useGetMenuItems = (deleteExclusion: (id: string, name: string) => void) => {
    const { setSelectedExclusion } = useContext(IncidentExclusionContext);

    const handleDelete = useCallback(
        (row?: Exclusion) => {
            if (row?.id && row?.name) {
                deleteExclusion(row.id, row.name);
            }
        },
        [deleteExclusion]
    );

    return useMemo<ListItemProps<Exclusion>[]>(
        () => [
            {
                title: 'Edit',
                IconLeft: Icons.Edit,
                onClick: (row) => setSelectedExclusion(row)
            },
            {
                title: 'Delete',
                IconLeft: Icons.Delete,
                onClick: handleDelete
            }
        ],
        [handleDelete, setSelectedExclusion]
    );
};

export default useGetMenuItems;
